import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import userSlice from "./slices/userSlice";
import uiSlice from "./slices/uiSlice";
import themeSlice from "./slices/themeSlice";
import authReducer from "../redux/reducers/authReducer";
import logoReducer from "../redux/reducers/logoReducer";
import profileReducer from "../redux/reducers/profileReducer";
import settingReducer from "../redux/reducers/settingReducer";
import countryReducer from "../redux/reducers/countryReducer";

import dashboardReducer from "../redux/reducers/dashboardReducer/dashboardReducer";
import rootSaga from "../redux/sagas/rootSaga";
import oemReducer from "../redux/reducers/oemReducer";
import singleScanReducer from "../redux/reducers/scanReducer";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    user: userSlice,
    ui: uiSlice,
    theme: themeSlice,
    auth: authReducer,
    logo: logoReducer,
    profile: profileReducer,
    dashboard: dashboardReducer,
    oem: oemReducer,
    setting: settingReducer,
    singleScan : singleScanReducer,
    country: countryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
